import { getRequiredFields } from 'utils/form'

const fields = [
  {
    label: 'User type',
    name: 'userType',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: false,
    options: [{ value: 'add', label: 'Add a new user' }, { value: 'edit', label: 'Edit existing user' }],
    searchable: true,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please enter a user type',
  },
  {
    label: 'Username',
    name: 'username',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: false,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please enter a username',
  },
  {
    label: 'Status',
    name: 'status',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: false,
    options: [{ value: 'Active', label: 'Active' }, { value: 'Inactive', label: 'Inactive' }],
    searchable: true,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please enter a status',
  },
  {
    label: 'Role',
    name: 'role',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: false,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please enter a role',
  },
]

export const requiredFields = getRequiredFields(fields)
export const formFields = fields
export default formFields



// WEBPACK FOOTER //
// ./src/schemas/forms/ManagePermissions.js